import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {Lead} from "../../models/lead.model";
import {LeadService} from "../../providers/lead.service";
import {mobilePhoneNumberValidator, mustMatch} from "../../utils/form-validators";
import {Observable, Subscription} from "rxjs";
import {UserService} from "../../providers/user.service";
import {User} from "../../models/user.model";
import {Partner} from "../../models/partner.model";
import {PartnerService} from "../../providers/partner.service";
import {SimpleInnerHtmlModalComponent} from "../simple-inner-html-modal/simple-inner-html-modal.component";

@Component({
  selector: 'app-edit-lead',
  templateUrl: './edit-lead.component.html',
  styleUrls: ['./edit-lead.component.scss'],
})
export class EditLeadComponent extends GenericActionComponent implements OnInit, GenericActionComponentsMethods {

  @Input() lead: Lead;
  @Input() csrfToken: string;
  @Input() promotionalCode: string;

  @Output() objectEditedEmitter = new EventEmitter<Lead>();
  @Output() objectAddedEmitter = new EventEmitter<Lead>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();
  private loggedUser: User;
  private isAdmin: boolean = false;
  users: User[];
  private isGeneralAdmin: boolean = false;
  vClientUUID: string;
  partners: Partner[];
  offerTypes: string[] = [];
  editLeadLabel: string;
  isVetineoSales: boolean;
  isSalesManager: boolean = false;
  private userUUID: string;
  promotionalCodeIobAccepted: boolean = false;
  clinicTermsAccepted: boolean = false;

  voivodeships: string[] = [
    'DOLNOSLASKIE',
    'KUJAWSKO_POMORSKIE',
    'LUBELSKIE',
    'LUBUSKIE',
    'LODZKIE',
    'MALOPOLSKIE',
    'MAZOWIECKIE',
    'OPOLSKIE',
    'PODKARPACKIE',
    'PODLASKIE',
    'POMORSKIE',
    'SLASKIE',
    'SWIETOKRZYSKIE',
    'WARMINSKO_MAZURSKIE',
    'WIELKOPOLSKIE',
    'ZACHODNIOPOMORSKIE'
  ];
  subscriptions: Subscription = new Subscription();

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private leadService: LeadService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private partnerService: PartnerService,
    private userService: UserService,
  ) {
    super(commonUtils, appStateService, modalController, translateService,);
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    super.ngOnDestroy();
  }

  ngOnInit() {
    this.appStateService.updateIsBusySubject(true);
    this.prepareOfferTypes();
    this.userService.getUser().subscribe(u => {
      if (u && u.uuid) {
        this.loggedUser = u;
        this.isAdmin = this.filterRoleContains(u, 'admin');
        this.isSalesManager = this.filterRoleContains(u, 'sales-manager');
        this.isGeneralAdmin = this.isAdmin && !u.vClientId;
        this.isVetineoSales = this.filterRoleContains(u, 'vetineo-sales');

        if (this.isVetineoSales) {
          this.userUUID = u.uuid;
        }

        if (u.vClientUUID) {
          this.vClientUUID = u.vClientUUID;
          if (this.isAdmin || this.isSalesManager) {
            this.getUsers();
          }
        }
        if (!u.vClientUUID && (this.isGeneralAdmin || this.isVetineoSales)) {
          this.partnerService.listPartners().subscribe(e => {
            if (e) {
              this.partners = e;
              this.appStateService.updateIsBusySubject(false);
            }
          })
        }
        this.appStateService.updateIsBusySubject(false);

      }
    });
    if (this.loggedUser?.vClientUUID) {
      this.vClientUUID = this.loggedUser.vClientUUID;
    }

    if (this.action === 'EDIT' && this.lead && this.isGeneralAdmin) {
      this.vClientUUID = this.lead.vClientUUID;
      this.getUsers();
    }

    if (this.action === 'ADD') {
      if (this.loggedUser) {
        this.editLeadLabel = 'Dodaj nowy lead w systemie Vetineo';
        this.componentTitle = 'Dodaj nowego leada';
        this.actionBtnLabel = 'Dodaj lead';
        this.actionQuestion = 'Na pewno chcesz dodać lead?';
        this.actionSuccess = 'Lead został dodany';
        this.actionError = 'Wystąpił błąd podczas dodawania leada';
      } else {
        this.editLeadLabel = 'Podaj swoje dane';
        this.componentTitle = 'Uzupełnianie danych';
        this.actionBtnLabel = 'Zarejestruj konto Vetineo Plus';
        this.actionQuestion = 'Na pewno chcesz zrealizować swój kod i zarejestrować konto Vetineo Plus?';
        this.actionSuccess = 'Dziękujemy za rozpoczęcie procesu rejestracji konta Vetineo Plus';
        this.actionError = 'Wystąpił błąd podczas rozpoczęcia procesu rejestracji konta Vetineo Plus';
      }

      if (this.promotionalCode) {
        this.formGroup = this.formBuilder.group({
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          name: ['', Validators.required],
          phone: ['', [Validators.required, mobilePhoneNumberValidator]],
          email: ['', [Validators.email, Validators.required]],
          postalCode: ['', Validators.required],
          city: ['', Validators.required],
          street: ['', Validators.required],
          voivodeship: ['', Validators.required],
          retypeEmail: ['', Validators.required],
          offerType: ['VET_PLANET_PROMOTIONAL_CODE', Validators.required],
          nip: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.required,
            Validators.pattern("^[0-9]*$")]],
        }, {validators: mustMatch('email', 'retypeEmail')});
      } else {
        if (this.isGeneralAdmin && !this.loggedUser.vClientId) {
          this.formGroup = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            name: ['', Validators.required],
            phone: ['', [Validators.required, mobilePhoneNumberValidator]],
            email: ['', [Validators.email, Validators.required]],
            postalCode: ['', Validators.required],
            city: ['', Validators.required],
            street: ['', Validators.required],
            vClientUUID: ['', Validators.required],
            userUUID: ['', Validators.required],
            voivodeship: ['', Validators.required],
            comment: [''],
            retypeEmail: ['', Validators.required],
            offerType: ['STANDARD', Validators.required],
            nip: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.required,
              Validators.pattern("^[0-9]*$")]],
          }, {validators: mustMatch('email', 'retypeEmail')});
        } else {
          if ((this.isAdmin || this.isSalesManager) && this.loggedUser.vClientId) {
            this.formGroup = this.formBuilder.group({
              firstName: ['', Validators.required],
              lastName: ['', Validators.required],
              name: ['', Validators.required],
              phone: ['', [Validators.required, mobilePhoneNumberValidator]],
              email: ['', [Validators.email, Validators.required]],
              postalCode: ['', Validators.required],
              city: ['', Validators.required],
              street: ['', Validators.required],
              userUUID: ['', Validators.required],
              voivodeship: ['', Validators.required],
              comment: [''],
              retypeEmail: ['', Validators.required],
              offerType: ['STANDARD', Validators.required],
              nip: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.required,
                Validators.pattern("^[0-9]*$")]],
            }, {validators: mustMatch('email', 'retypeEmail')});
          } else {
            this.formGroup = this.formBuilder.group({
              firstName: ['', Validators.required],
              lastName: ['', Validators.required],
              name: ['', Validators.required],
              phone: ['', [Validators.required, mobilePhoneNumberValidator]],
              email: ['', [Validators.email, Validators.required]],
              postalCode: ['', Validators.required],
              city: ['', Validators.required],
              street: ['', Validators.required],
              voivodeship: ['', Validators.required],
              comment: [''],
              retypeEmail: ['', Validators.required],
              offerType: ['STANDARD', Validators.required],
              nip: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.required,
                Validators.pattern("^[0-9]*$")]],
            }, {validators: mustMatch('email', 'retypeEmail')});
          }
        }
      }
    } else {
      this.componentTitle = 'Zmień lead';
      this.actionBtnLabel = 'Zmień lead';
      this.actionQuestion = 'Na pewno chcesz zmienić lead?';
      this.actionSuccess = 'Lead został zmieniony';
      this.actionError = 'Wystąpił błąd podczas zmiany leada';
      this.editLeadLabel = 'Edytuj lead w systemie Vetineo';
      if (this.isAdmin || this.isSalesManager) {
        this.users = [];
        this.users.push(this.lead.user);
        this.formGroup = this.formBuilder.group({
          firstName: [this.lead.firstName, Validators.required],
          lastName: [this.lead.lastName, Validators.required],
          name: [this.lead.name, Validators.required],
          phone: [this.lead.phone, [Validators.required, mobilePhoneNumberValidator]],
          email: [this.lead.email, [Validators.email, Validators.required]],
          postalCode: [this.lead.postalCode, Validators.required],
          city: [this.lead.city, Validators.required],
          userUUID: [this.lead.userUUID, Validators.required],
          street: [this.lead.street, Validators.required],
          voivodeship: [this.lead.voivodeship, Validators.required],
          comment: [this.lead.comment],
          retypeEmail: [this.lead.email, Validators.required],
          offerType: [this.lead.offerType, Validators.required],
          nip: [this.lead.nip, [Validators.minLength(10), Validators.maxLength(10), Validators.required,
            Validators.pattern("^[0-9]*$")]],
        }, {validators: mustMatch('email', 'retypeEmail')});

      } else {
        this.formGroup = this.formBuilder.group({
          firstName: [this.lead.firstName, Validators.required],
          lastName: [this.lead.lastName, Validators.required],
          name: [this.lead.name, Validators.required],
          phone: [this.lead.phone, [Validators.required, mobilePhoneNumberValidator]],
          email: [this.lead.email, [Validators.email, Validators.required]],
          postalCode: [this.lead.postalCode, Validators.required],
          city: [this.lead.city, Validators.required],
          street: [this.lead.street, Validators.required],
          voivodeship: [this.lead.voivodeship, Validators.required],
          comment: [this.lead.comment],
          retypeEmail: [this.lead.email, Validators.required],
          offerType: [this.lead.offerType, Validators.required],
          nip: [this.lead.nip, [Validators.minLength(10), Validators.maxLength(10), Validators.required,
            Validators.pattern("^[0-9]*$")]],
        }, {validators: mustMatch('email', 'retypeEmail')});
      }

    }
    super.ngOnInit();
  }

  onAction() {
    this.commonUtils.presentYesNoActionSheet(this.actionQuestion, 'Tak', 'Nie', 'checkmark', 'close', () => {
      let leadObj: Lead = this.commonUtils.formGroupValuesToObject<Lead>(new Lead(), this.formGroup);
      let serviceMethod;
      console.log(leadObj)


      if (this.promotionalCode) {
        leadObj.promotionalCode = this.promotionalCode;
        serviceMethod = this.leadService.addLeadWithPromotionalCode(leadObj);
      } else {
        if (this.action === 'EDIT') {
          leadObj.uuid = this.lead.uuid;
          serviceMethod = this.leadService.updateLead(leadObj);
        } else {
          if (this.isVetineoSales) {
            leadObj.vClientUUID = 'e7e308bf-6f11-4a09-894f-31477447240d';
            leadObj.userUUID = this.userUUID;
          }
          serviceMethod = this.leadService.addLead(leadObj);
        }
      }


      this.handleActionMethodForAddingLead(serviceMethod, this.objectAddedEmitter, this.objectEditedEmitter);

    }, () => {
    });
  }

  override


  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  private handleActionMethodForAddingLead(serviceMethod: Observable<Lead>, objectAddedEmitter: EventEmitter<Lead>, objectEditedEmitter: EventEmitter<Lead>) {
    this.appStateService.updateIsBusySubject(true);

    serviceMethod.subscribe((obj: Lead) => {
        this.appStateService.updateIsBusySubject(false);
        if (obj && obj.uuid) {
          this.commonUtils.presentInfoToast(this.actionSuccess).then(res => {

            if (this.action === 'ADD') {
              objectAddedEmitter.emit(obj);
            } else {
              objectEditedEmitter.emit(obj);
            }
            this.hasUnsavedChanges = false;
          });
        } else {
          //todo zmiana na kontakt z VCLienta
          this.commonUtils.presentAlertToast('Dany NIP jest już zarejestrowany skontaktuj się z administratorem');
        }
      },
      error => {

        switch(error.message) {
          case 'REGISTRATION_CODE_NOT_ALLOWED_YET': {
            this.commonUtils.presentAlertToast('Nie można jeszcze rejestrować kodów');
            this.appStateService.updateIsBusySubject(false);
            break;
          }
          case 'REGISTRATION_CODE_ALREADY_USED': {
            this.commonUtils.presentAlertToast('Nie można zarejestrować tego kodu');
            this.appStateService.updateIsBusySubject(false);
            break;
          }
          default: {
            this.commonUtils.presentAlertToast(this.actionError);
            this.appStateService.updateIsBusySubject(false);
            break;
          }
        }


      });
  }

  filterRoleContains(user: User, role: string) {
    return user.roles?.split(';').filter(e => e === role).length === 1;
  }

  onSelectClient($event) {
    this.markUnsavedChanges();
    this.vClientUUID = $event.detail.value;
    this.getUsers();
  }

  getUsers() {
    this.appStateService.updateIsBusySubject(true);
    this.userService.listSalesRepresentatives(this.vClientUUID).subscribe(e => {
      this.users = e;
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    })
  }

  private prepareOfferTypes() {
    this.offerTypes.push('STANDARD');
    this.offerTypes.push('ZOETIS_SO');
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  validForPromotionalCode() {
    if (this.promotionalCode) {
      return this.promotionalCodeIobAccepted && this.clinicTermsAccepted;
    } else {
      return true;
    }
  }

  async opentClinicTermsModal() {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.leadService.getClinicTerms().subscribe(async terms => {
      this.appStateService.updateIsBusySubject(false);
      if (terms) {
        const modal = await this.modalController.create({
          component: SimpleInnerHtmlModalComponent,
          componentProps: {
            title: 'Regulamin dla praktyk',
            iob: terms
          },
          cssClass: 'bigger-modal'
        });
        modal.onWillDismiss().then(data => {
        });
        return await modal.present();
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }

  async openPromotionalCodeIob() {
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.leadService.getPromotionalCodeIob().subscribe(async iob => {
      this.appStateService.updateIsBusySubject(false);
      if (iob) {
        const modal = await this.modalController.create({
          component: SimpleInnerHtmlModalComponent,
          componentProps: {
            title: 'Obowiązek informacyjny',
            iob: iob
          },
          cssClass: 'bigger-modal'
        });
        modal.onWillDismiss().then(data => {
        });
        return await modal.present();
      }
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }

}



